module.exports = __webpack_public_path__ + "static/media/scrum_icon.9c95fb20.png";